/**
 * MeetingSideCards (TASK-715) — the meeting scope's proposal cards under an
 * assistant message: task/action proposals (Apply creates the task) and
 * blocked portfolio proposals (failed rails + alternatives). Brief updates
 * render inline in BriefTab, not here (parity with the deleted PrepChatPanel).
 */

import React from 'react';
import { ActionProposalCard } from '../meeting/preparation/ActionProposalCard';
import { BlockedProposalCard } from '../meeting/preparation/BlockedProposalCard';
import { useMeetingPrepBridge } from '../../stores/meetingPrepBridge';
import type { ProposalActionItem } from '../../types/prepChat.types';

export interface MeetingSideCardsProps {
  actionProposals?: ProposalActionItem[];
  proposalActions?: ProposalActionItem[];
  onRevise?: (prompt: string) => void;
}

export const MeetingSideCards: React.FC<MeetingSideCardsProps> = ({
  actionProposals,
  proposalActions,
  onRevise,
}) => {
  // Only `blocked` proposal actions render as cards — create/update/remove are
  // consumed by the PreparationPage bridge (composer prefill / proposal store).
  const blocked = (proposalActions ?? []).filter((p) => p.action === 'blocked');
  const tasks = actionProposals ?? [];
  if (blocked.length === 0 && tasks.length === 0) return null;

  return (
    <div className="ml-9 space-y-2">
      {tasks.map((p, i) => (
        <ActionProposalCard key={`ap-${i}`} proposal={p} />
      ))}
      {blocked.map((p, i) => (
        <BlockedProposalCard
          key={`bp-${i}`}
          proposal={p}
          onRevise={onRevise}
          // Same recovery the deleted PrepChatPanel offered: an empty composer on
          // the Proposals tab so the advisor builds the trades by hand.
          onOpenComposer={() => useMeetingPrepBridge.getState().switchTab('proposals')}
        />
      ))}
    </div>
  );
};
